import React, { CSSProperties } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import palette from '@ui/palette';
import { useLayoutContext } from '../../context/LayoutContext';
import {
  RIGHT_RAIL_WIDTH,
  RIGHT_RAIL_WIDTH_COLLAPSED,
  RightRailProps,
} from '.';

type InlineRightRailProps = RightRailProps;

const useInlineStyles = makeStyles()(theme => ({
  root: {
    height: '100%',
    gridArea: 'right',
    overflow: 'hidden',
    visibility: 'hidden',
    width: RIGHT_RAIL_WIDTH_COLLAPSED,
    transition: theme.transitions.create(['width', 'visibility'], {
      easing: 'cubic-bezier(0.25, 0.25, 0.5, 1)',
      duration: 600,
    }),
    zIndex: theme.zIndex.drawer + 1,
    /**
     * @todo - Move this background color declaration to the children being passed
     * Was added here as a quick styling fix
     */
    backgroundColor: palette.gray_1100,
  },
  open: {
    borderLeft: `1px solid ${palette.gray_800}`,
    visibility: 'visible',
    width: RIGHT_RAIL_WIDTH,
  },
  scrollable: {
    overflowY: 'scroll',
    ...(theme.mixins.scrollBar as CSSProperties),
  },
  subRoot: {
    width: RIGHT_RAIL_WIDTH,
    height: '100%',
  },
}));

/**
 * @description A layout component for the Right Rail that implements an inline approach to displaying it in the page,
 *  i.e. this rail will push the siblings for space in the container.
 */
export default function InlineRightRail({ children }: InlineRightRailProps) {
  const { classes, cx } = useInlineStyles();
  const { isRightRailOpen, rightRailScrollable } = useLayoutContext();

  return (
    <Box
      className={cx(classes.root, {
        [classes.open]: isRightRailOpen,
        [classes.scrollable]: rightRailScrollable,
      })}
    >
      <Box className={classes.subRoot}>{children}</Box>
    </Box>
  );
}
